import { render, staticRenderFns } from "./SepaForm.vue?vue&type=template&id=63f5dfc5&scoped=true&"
import script from "./SepaForm.vue?vue&type=script&lang=js&"
export * from "./SepaForm.vue?vue&type=script&lang=js&"
import style0 from "./SepaForm.vue?vue&type=style&index=0&id=63f5dfc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f5dfc5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
